var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title-icon clear"},[_c('div',{staticClass:"content"},[_c('b',{staticClass:"font-heading-2 title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"font-color-sub"},[_vm._v(_vm._s(_vm.sub))])])])}
var staticRenderFns = []

export { render, staticRenderFns }